import { css, Theme } from "@emotion/react";

export const container = (theme: Theme) =>
    css({
        ...theme.candy.typography.primary.css(),
        position: "relative",
        minHeight: "300px",
        display: "flex",
        flexDirection: "column",
    });

export const loader = (theme: Theme) =>
    css({
        paddingLeft: 40,
        marginLeft: -40,
        zIndex: 100,
        backgroundColor: theme.candy.keyPalette.primaryBackgroundColor,
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    });

export const delimiter = (theme: Theme) =>
    css({
        marginLeft: "7px",
        marginRight: "7px",
        marginBottom: "2px",
        marginTop: "2px",
        border: 0,
        borderTop: "1px solid",
        flex: 0,
        borderColor: theme.candy.typography.secondary.color,
    });

export const input = css({
    paddingBottom: 10,
    flex: 0,
});

export const text = (theme: Theme) =>
    css({
        color: theme.candy.typography.secondary.color,
    });
